export class MyClientsReSignEmailFauRequestModel {
    id: string; // Id que se genera en la plataforma
    idOld: number | null; // Dependencia de 1re servicio
    radicacion: number;
    direccion: string;
    ciudad: string;
    cupoComprador: number;
    documento: number;
    documentoAfiliado: number;
    nombreComprador: string;
    tipoDoc: string;
    tipoDocAfiliado: string;
    correosComprador: string[] = [];
    celulares: string[] = [];
    token?: string;
    urlCupo: string;
    urlLanding: string;
    whatsApp: boolean;
    sms: boolean;
    llamada: boolean;
    correoElectronico: boolean;
    fecha_expedicion: string;
    usuario: string;
  }
  